webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/table/_table.js
var _table = __webpack_require__("fnDg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/table/table.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var table = (_table["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/table/table.vue
function injectStyle (ssrContext) {
  __webpack_require__("4veK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  table,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var table_table = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/0bT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4veK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6mdz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8C+7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form-input/_form-input.js
var _form_input = __webpack_require__("qRo1");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var form_input = (_form_input["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
function injectStyle (ssrContext) {
  __webpack_require__("n9mN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_input,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_input_form_input = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/modal/_modal.js
var _modal = __webpack_require__("rKsW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/modal/modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var modal = (_modal["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/modal/modal.vue
function injectStyle (ssrContext) {
  __webpack_require__("xBwK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  modal,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var modal_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form-file/_form-file.js
var _form_file = __webpack_require__("9NuQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-file/form-file.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var form_file = (_form_file["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-file/form-file.vue
function injectStyle (ssrContext) {
  __webpack_require__("Y9O/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_file,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_file_form_file = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Header = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55cb4d63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"toggleable":"md","type":"dark","variant":"info"}},[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-navbar-brand',{attrs:{"to":"/"}},[_vm._v("MathMaker")]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',[_c('b-nav-item',{attrs:{"to":"/form","active-class":"hidden"}},[_vm._v("Get Started")])],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item',{directives:[{name:"b-modal",rawName:"v-b-modal.about",modifiers:{"about":true}}]},[_vm._v("About")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"about","title":"MathMaker","lazy":"","hide-footer":""}},[_c('p',[_vm._v("A CS50 Final Project by "),_c('a',{attrs:{"href":"http://twitter.com/mcklatch"}},[_vm._v("David McClatchey")]),_vm._v(" "),_c('br'),_c('br'),_vm._v("\n      Originally made using Python, Django, Jinja2, JavaScript, Jquery, Bootstrap, AJAX.\n      "),_c('br'),_c('br'),_vm._v("\n      This version made entirely in VueJS2 with vuex, vue-router, and bootstrap-vue")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Header = (esExports);
// CONCATENATED MODULE: ./src/components/Header.vue
function injectStyle (ssrContext) {
  __webpack_require__("6mdz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Header,
  components_Header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Header = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Footer.vue
//
//
//
//

/* harmony default export */ var Footer = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7b8316","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
var Footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Footer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-muted text-center"},[_vm._v("Made by "),_c('a',{attrs:{"href":"https://mcklatch.com/hi","rel":"noreferrer","target":"_blank"}},[_vm._v("McKlatch")]),_vm._v(" - see more at "),_c('a',{attrs:{"href":"https://dev.mcklatch.com","rel":"noreferrer","target":"_blank"}},[_vm._v("dev.mcklatch.com")])])}]
var Footer_esExports = { render: Footer_render, staticRenderFns: Footer_staticRenderFns }
/* harmony default export */ var components_Footer = (Footer_esExports);
// CONCATENATED MODULE: ./src/components/Footer.vue
function Footer_injectStyle (ssrContext) {
  __webpack_require__("vV5b")
}
var Footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Footer___vue_template_functional__ = false
/* styles */
var Footer___vue_styles__ = Footer_injectStyle
/* scopeId */
var Footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Footer___vue_module_identifier__ = null
var Footer_Component = Footer_normalizeComponent(
  Footer,
  components_Footer,
  Footer___vue_template_functional__,
  Footer___vue_styles__,
  Footer___vue_scopeId__,
  Footer___vue_module_identifier__
)

/* harmony default export */ var src_components_Footer = (Footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
  name: 'app',
  components: { appHeader: src_components_Header, appFooter: src_components_Footer }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5bef434","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('app-footer')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("bDFw")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloWorld.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HelloWorld = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f3600bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
var HelloWorld_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-jumbotron',[_c('template',{slot:"header"},[_vm._v("\n    MathMaker\n  ")]),_vm._v(" "),_c('template',{slot:"lead"},[_vm._v("\n    Randomly generated maths exercises for teachers to share with children.\n    "),_c('br'),_vm._v("\n    Aimed at UK Key Stage 1 and 2.\n  ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("\n    Entire project made personally with all features designed and implemented by "),_c('a',{attrs:{"href":"https://mcklatch.com/hi","rel":"noopener noreferrer","target":"_blank"}},[_vm._v("David McClatchey")]),_vm._v(".\n    "),_c('br'),_vm._v("\n    Made to the specifications of the final project assignment at "),_c('a',{attrs:{"href":"http://cs50.tv/2016/fall/","rel":"noopener noreferrer","target":"_blank"}},[_vm._v("Harvard CS50")]),_vm._v(" 2016.\n  ")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"primary","to":"/form"}},[_vm._v("Get Started")])],2)}
var HelloWorld_staticRenderFns = []
var HelloWorld_esExports = { render: HelloWorld_render, staticRenderFns: HelloWorld_staticRenderFns }
/* harmony default export */ var components_HelloWorld = (HelloWorld_esExports);
// CONCATENATED MODULE: ./src/components/HelloWorld.vue
function HelloWorld_injectStyle (ssrContext) {
  __webpack_require__("/0bT")
}
var HelloWorld_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HelloWorld___vue_template_functional__ = false
/* styles */
var HelloWorld___vue_styles__ = HelloWorld_injectStyle
/* scopeId */
var HelloWorld___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HelloWorld___vue_module_identifier__ = null
var HelloWorld_Component = HelloWorld_normalizeComponent(
  HelloWorld,
  components_HelloWorld,
  HelloWorld___vue_template_functional__,
  HelloWorld___vue_styles__,
  HelloWorld___vue_scopeId__,
  HelloWorld___vue_module_identifier__
)

/* harmony default export */ var src_components_HelloWorld = (HelloWorld_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/index.js
var dist = __webpack_require__("GDE4");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/Quantity.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Quantity = ({
  data: function data() {
    return {
      questionQuantitySlider: {
        eventType: 'auto',
        width: 'auto',
        height: 6,
        dotSize: 16,
        min: 0,
        max: 0,
        interval: 1,
        show: true,
        speed: 0.5,
        tooltip: 'always',
        tooltipDir: 'top',
        clickable: true
      }
    };
  },

  computed: {
    questionQuantity: {
      get: function get() {
        return this.$store.state.formInput.questionQuantity;
      },
      set: function set(value) {
        this.$store.dispatch('updateQuantity', value);
      }
    }
  },
  created: function created() {
    this.questionQuantitySlider.min = this.$store.state.formOptions.questionQuantity.min;
    this.questionQuantitySlider.max = this.$store.state.formOptions.questionQuantity.max;
  },

  components: {
    vueSlider: dist_default.a
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a957076","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Quantity.vue
var Quantity_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"Question Quantity:"}},[_c('vue-slider',_vm._b({attrs:{"name":"quantity"},model:{value:(_vm.questionQuantity),callback:function ($$v) {_vm.questionQuantity=$$v},expression:"questionQuantity"}},'vue-slider',_vm.questionQuantitySlider,false))],1)}
var Quantity_staticRenderFns = []
var Quantity_esExports = { render: Quantity_render, staticRenderFns: Quantity_staticRenderFns }
/* harmony default export */ var form_Quantity = (Quantity_esExports);
// CONCATENATED MODULE: ./src/components/form/Quantity.vue
var Quantity_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Quantity___vue_template_functional__ = false
/* styles */
var Quantity___vue_styles__ = null
/* scopeId */
var Quantity___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Quantity___vue_module_identifier__ = null
var Quantity_Component = Quantity_normalizeComponent(
  Quantity,
  form_Quantity,
  Quantity___vue_template_functional__,
  Quantity___vue_styles__,
  Quantity___vue_scopeId__,
  Quantity___vue_module_identifier__
)

/* harmony default export */ var components_form_Quantity = (Quantity_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/Operators.vue
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Operators = ({
  data: function data() {
    return {
      includeOperatorsOptions: []
    };
  },

  computed: {
    includeOperators: {
      get: function get() {
        return this.$store.state.formInput.includeOperators;
      },
      set: function set(value) {
        this.$store.dispatch('updateOperators', value);
      }
    }
  },
  created: function created() {
    this.includeOperatorsOptions = this.$store.state.formOptions.includeOperators;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df67ae84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Operators.vue
var Operators_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox-group',{attrs:{"id":"operatorsInput","name":"operators"},model:{value:(_vm.includeOperators),callback:function ($$v) {_vm.includeOperators=$$v},expression:"includeOperators"}},_vm._l((_vm.includeOperatorsOptions),function(o){return _c('b-form-checkbox',{key:o,attrs:{"value":o}},[_vm._v("\n      "+_vm._s(o)+"\n    ")])}),1)}
var Operators_staticRenderFns = []
var Operators_esExports = { render: Operators_render, staticRenderFns: Operators_staticRenderFns }
/* harmony default export */ var form_Operators = (Operators_esExports);
// CONCATENATED MODULE: ./src/components/form/Operators.vue
var Operators_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Operators___vue_template_functional__ = false
/* styles */
var Operators___vue_styles__ = null
/* scopeId */
var Operators___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Operators___vue_module_identifier__ = null
var Operators_Component = Operators_normalizeComponent(
  Operators,
  form_Operators,
  Operators___vue_template_functional__,
  Operators___vue_styles__,
  Operators___vue_scopeId__,
  Operators___vue_module_identifier__
)

/* harmony default export */ var components_form_Operators = (Operators_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/Sample.vue
//
//
//
//
//
//
//
//


/* harmony default export */ var Sample = ({
  computed: {
    sampleEquation: function sampleEquation() {
      return this.$store.getters.equationArray[0];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f25f872","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Sample.vue
var Sample_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-row',{staticClass:"text-center"},[_c('b-col',[_c('h1',[_vm._v(_vm._s(_vm.sampleEquation.question)+" = "+_vm._s(_vm.sampleEquation.answer))])])],1)}
var Sample_staticRenderFns = []
var Sample_esExports = { render: Sample_render, staticRenderFns: Sample_staticRenderFns }
/* harmony default export */ var form_Sample = (Sample_esExports);
// CONCATENATED MODULE: ./src/components/form/Sample.vue
var Sample_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Sample___vue_template_functional__ = false
/* styles */
var Sample___vue_styles__ = null
/* scopeId */
var Sample___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Sample___vue_module_identifier__ = null
var Sample_Component = Sample_normalizeComponent(
  Sample,
  form_Sample,
  Sample___vue_template_functional__,
  Sample___vue_styles__,
  Sample___vue_scopeId__,
  Sample___vue_module_identifier__
)

/* harmony default export */ var components_form_Sample = (Sample_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/constant/Range.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Range = ({
  props: ['constant'],
  data: function data() {
    return {
      rangeSlider: {
        eventType: 'auto',
        width: 'auto',
        height: 6,
        dotSize: 16,
        min: 0,
        max: 0,
        interval: 1,
        show: true,
        speed: 0.5,
        tooltip: 'always',
        tooltipDir: 'top',
        clickable: true
      }
    };
  },

  computed: {
    range: {
      get: function get() {
        return this.$store.state.formInput.constants[this.constant].range;
      },
      set: function set(value) {
        this.$store.dispatch('updateRange', { constant: this.constant, value: value });
      }
    }
  },
  created: function created() {
    this.rangeSlider.min = this.$store.state.formOptions.constantRange.min;
    this.rangeSlider.max = this.$store.state.formOptions.constantRange.max;
  },

  components: {
    vueSlider: dist_default.a
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79cc4e0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/constant/Range.vue
var Range_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"Values Between:"}},[_c('vue-slider',_vm._b({attrs:{"name":"between"},model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}},'vue-slider',_vm.rangeSlider,false))],1)}
var Range_staticRenderFns = []
var Range_esExports = { render: Range_render, staticRenderFns: Range_staticRenderFns }
/* harmony default export */ var constant_Range = (Range_esExports);
// CONCATENATED MODULE: ./src/components/form/constant/Range.vue
var Range_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Range___vue_template_functional__ = false
/* styles */
var Range___vue_styles__ = null
/* scopeId */
var Range___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Range___vue_module_identifier__ = null
var Range_Component = Range_normalizeComponent(
  Range,
  constant_Range,
  Range___vue_template_functional__,
  Range___vue_styles__,
  Range___vue_scopeId__,
  Range___vue_module_identifier__
)

/* harmony default export */ var form_constant_Range = (Range_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/constant/Multiples.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Multiples = ({
  props: ['constant'],
  computed: {
    constantMultiplesOptions: function constantMultiplesOptions() {
      return this.$store.getters.constantMultiplesOptions(this.constant);
    },

    multiples: {
      get: function get() {
        return this.$store.state.formInput.constants[this.constant].multiples;
      },
      set: function set(value) {
        this.$store.dispatch('updateMultiples', { constant: this.constant, value: value });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53417f64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/constant/Multiples.vue
var Multiples_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox-group',{attrs:{"name":"multiples"},model:{value:(_vm.multiples),callback:function ($$v) {_vm.multiples=$$v},expression:"multiples"}},_vm._l((_vm.constantMultiplesOptions),function(o){return _c('b-form-checkbox',{key:o,attrs:{"value":o}},[_vm._v("\n      "+_vm._s(o)+"\n    ")])}),1)}
var Multiples_staticRenderFns = []
var Multiples_esExports = { render: Multiples_render, staticRenderFns: Multiples_staticRenderFns }
/* harmony default export */ var constant_Multiples = (Multiples_esExports);
// CONCATENATED MODULE: ./src/components/form/constant/Multiples.vue
var Multiples_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Multiples___vue_template_functional__ = false
/* styles */
var Multiples___vue_styles__ = null
/* scopeId */
var Multiples___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Multiples___vue_module_identifier__ = null
var Multiples_Component = Multiples_normalizeComponent(
  Multiples,
  constant_Multiples,
  Multiples___vue_template_functional__,
  Multiples___vue_styles__,
  Multiples___vue_scopeId__,
  Multiples___vue_module_identifier__
)

/* harmony default export */ var form_constant_Multiples = (Multiples_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/constant/Constant.vue
//
//
//
//
//
//
//




/* harmony default export */ var Constant = ({
  props: ['constant'],
  components: {
    formRange: form_constant_Range,
    formMultiples: form_constant_Multiples
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4348e0a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/constant/Constant.vue
var Constant_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('form-multiples',{attrs:{"constant":_vm.constant}}),_vm._v(" "),_c('form-range',{attrs:{"constant":_vm.constant}})],1)}
var Constant_staticRenderFns = []
var Constant_esExports = { render: Constant_render, staticRenderFns: Constant_staticRenderFns }
/* harmony default export */ var constant_Constant = (Constant_esExports);
// CONCATENATED MODULE: ./src/components/form/constant/Constant.vue
var Constant_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Constant___vue_template_functional__ = false
/* styles */
var Constant___vue_styles__ = null
/* scopeId */
var Constant___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Constant___vue_module_identifier__ = null
var Constant_Component = Constant_normalizeComponent(
  Constant,
  constant_Constant,
  Constant___vue_template_functional__,
  Constant___vue_styles__,
  Constant___vue_scopeId__,
  Constant___vue_module_identifier__
)

/* harmony default export */ var form_constant_Constant = (Constant_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/Params.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Params = ({
  computed: {
    isNeg: function isNeg() {
      return this.$store.state.formInput.includeOperators.includes('➖');
    },
    isDiv: function isDiv() {
      return this.$store.state.formInput.includeOperators.includes('➗');
    },

    includeNegativeAns: {
      get: function get() {
        return this.$store.state.formInput.subtractionVars.includeNegativeAns;
      },
      set: function set(value) {
        this.$store.dispatch('updateNegativeAns', value === 'true');
      }
    },
    wholeAnsOnly: {
      get: function get() {
        return this.$store.state.formInput.divisionVars.wholeAnsOnly;
      },
      set: function set(value) {
        this.$store.dispatch('updatewholeAnsOnly', value === 'true');
      }
    },
    modularRemainders: {
      get: function get() {
        return this.$store.state.formInput.divisionVars.modularRemainders;
      },
      set: function set(value) {
        this.$store.dispatch('updatemodularRemainders', value === 'true');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f624fbf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Params.vue
var Params_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isNeg)?_c('b-form-checkbox',{attrs:{"id":"includeNegativeAns","value":"true","unchecked-value":"false"},model:{value:(_vm.includeNegativeAns),callback:function ($$v) {_vm.includeNegativeAns=$$v},expression:"includeNegativeAns"}},[_vm._v("\n    Include Negative Answers\n  ")]):_vm._e(),_vm._v(" "),(_vm.isDiv)?_c('b-form-checkbox',{attrs:{"id":"wholeAnsOnly","value":"true","unchecked-value":"false"},model:{value:(_vm.wholeAnsOnly),callback:function ($$v) {_vm.wholeAnsOnly=$$v},expression:"wholeAnsOnly"}},[_vm._v("\n    Whole Answers Only\n  ")]):_vm._e(),_vm._v(" "),(_vm.isDiv)?_c('b-form-checkbox',{attrs:{"id":"modularRemainders","value":"true","unchecked-value":"false"},model:{value:(_vm.modularRemainders),callback:function ($$v) {_vm.modularRemainders=$$v},expression:"modularRemainders"}},[_vm._v("\n    Modular Remainders\n  ")]):_vm._e()],1)}
var Params_staticRenderFns = []
var Params_esExports = { render: Params_render, staticRenderFns: Params_staticRenderFns }
/* harmony default export */ var form_Params = (Params_esExports);
// CONCATENATED MODULE: ./src/components/form/Params.vue
var Params_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Params___vue_template_functional__ = false
/* styles */
var Params___vue_styles__ = null
/* scopeId */
var Params___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Params___vue_module_identifier__ = null
var Params_Component = Params_normalizeComponent(
  Params,
  form_Params,
  Params___vue_template_functional__,
  Params___vue_styles__,
  Params___vue_scopeId__,
  Params___vue_module_identifier__
)

/* harmony default export */ var components_form_Params = (Params_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/Form.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Form = ({
  computed: {
    form: function form() {
      return this.$store.state.formInput;
    },
    isOp: function isOp() {
      return this.form.includeOperators.length > 0;
    },
    constants: function constants() {
      return this.$store.getters.constantsAvailable;
    }
  },
  methods: {
    onSubmit: function onSubmit(evt) {
      evt.preventDefault();
      // alert(JSON.stringify(this.form))
      this.$router.push('generated');
    },
    onReset: function onReset(evt) {
      evt.preventDefault();
      this.$store.dispatch('resetAllInputs');
    }
  },
  created: function created() {
    this.$store.dispatch('resetAllInputs');
  },

  components: {
    formQuantity: components_form_Quantity,
    formOperators: components_form_Operators,
    formConstant: form_constant_Constant,
    formParams: components_form_Params,
    formSample: components_form_Sample
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27595057","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Form.vue
var Form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{attrs:{"align-h":"center","no-gutters":""}},[_c('b-col',{attrs:{"lg":"8","md":"10","sm":"12"}},[_c('b-form',{on:{"submit":_vm.onSubmit,"reset":_vm.onReset}},[_c('form-quantity'),_vm._v(" "),_c('form-operators'),_vm._v(" "),(_vm.isOp)?_c('form-sample'):_vm._e(),_vm._v(" "),_c('b-form-row',_vm._l((_vm.constants),function(constant){return _c('form-constant',{key:constant-1,attrs:{"constant":constant-1}})}),1),_vm._v(" "),_c('form-params'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary","disabled":!_vm.isOp}},[_vm._v("Submit")]),_vm._v(" "),_c('b-button',{attrs:{"type":"reset","variant":"secondary","size":"sm"}},[_vm._v("Restart")])],1)],1)],1)],1)}
var Form_staticRenderFns = []
var Form_esExports = { render: Form_render, staticRenderFns: Form_staticRenderFns }
/* harmony default export */ var form_Form = (Form_esExports);
// CONCATENATED MODULE: ./src/components/form/Form.vue
function Form_injectStyle (ssrContext) {
  __webpack_require__("8C+7")
}
var Form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Form___vue_template_functional__ = false
/* styles */
var Form___vue_styles__ = Form_injectStyle
/* scopeId */
var Form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Form___vue_module_identifier__ = null
var Form_Component = Form_normalizeComponent(
  Form,
  form_Form,
  Form___vue_template_functional__,
  Form___vue_styles__,
  Form___vue_scopeId__,
  Form___vue_module_identifier__
)

/* harmony default export */ var components_form_Form = (Form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Generated.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Generated = ({
  data: function data() {
    return {
      hideAnswers: false
    };
  },

  computed: {
    equationArray: function equationArray() {
      return this.$store.getters.equationArray;
    }
  },
  methods: {
    download: function download(evt) {
      var filename = 'mathmaker.txt';
      var content = 'MathMaker.8bitEphod.com\n\n';
      content += 'Questions Only:\n';
      for (var i = 0; i < this.equationArray.length; i++) {
        content += i + 1 + '. ' + this.equationArray[i].question + ' = \n';
      }
      content += '\nWith Answers:\n';
      for (var _i = 0; _i < this.equationArray.length; _i++) {
        content += _i + 1 + '. ' + this.equationArray[_i].question + ' = ' + this.equationArray[_i].answer + '\n';
      }
      content += '\nGenerated ' + new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear();
      this.downloadFile(filename, content);
    },
    downloadFile: function downloadFile(filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45bd9aee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Generated.vue
var Generated_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"lg":"4","md":"6","sm":"12"}},[_c('b-list-group',[_c('b-list-group-item',{attrs:{"active":""}},[_vm._v("\n        Questions Only\n        ")]),_vm._v(" "),_vm._l((_vm.equationArray),function(equation,index){return _c('b-list-group-item',{key:"index"},[_vm._v("\n          "+_vm._s(equation.question)+" = \n        ")])})],2)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"4","md":"6","sm":"12"}},[_c('b-list-group',[_c('b-list-group-item',{attrs:{"active":""}},[_vm._v("\n          With Answers\n          "),_c('b-button',{staticClass:"float-right",attrs:{"size":"sm"},on:{"click":function($event){_vm.hideAnswers = !_vm.hideAnswers}}},[_vm._v("\n            hide answers\n          ")])],1),_vm._v(" "),_vm._l((_vm.equationArray),function(equation,index){return _c('b-list-group-item',{key:"index"},[_vm._v("\n          "+_vm._s(equation.question)+" = "+_vm._s(!_vm.hideAnswers ? equation.answer : '')+"\n        ")])})],2)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"lg":"8","md":"10","sm":"12"}},[_c('b-button',{staticClass:"float-right",attrs:{"variant":"outline-secondary"},on:{"click":_vm.download}},[_vm._v("\n        Download as .txt\n      ")])],1)],1)],1)}
var Generated_staticRenderFns = []
var Generated_esExports = { render: Generated_render, staticRenderFns: Generated_staticRenderFns }
/* harmony default export */ var components_Generated = (Generated_esExports);
// CONCATENATED MODULE: ./src/components/Generated.vue
function Generated_injectStyle (ssrContext) {
  __webpack_require__("jQ72")
}
var Generated_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Generated___vue_template_functional__ = false
/* styles */
var Generated___vue_styles__ = Generated_injectStyle
/* scopeId */
var Generated___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Generated___vue_module_identifier__ = null
var Generated_Component = Generated_normalizeComponent(
  Generated,
  components_Generated,
  Generated___vue_template_functional__,
  Generated___vue_styles__,
  Generated___vue_scopeId__,
  Generated___vue_module_identifier__
)

/* harmony default export */ var src_components_Generated = (Generated_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'HelloWorld',
    component: src_components_HelloWorld
  }, {
    path: '/form',
    name: 'Form',
    component: components_form_Form
  }, {
    path: '/generated',
    name: 'Generated',
    component: src_components_Generated
  }]
}));
// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/index.js + 121 modules
var es = __webpack_require__("e6fC");

// EXTERNAL MODULE: ./src/store/store.js
var store = __webpack_require__("wtEF");

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__("Jmt5");
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/dist/bootstrap-vue.css
var bootstrap_vue = __webpack_require__("9M+g");
var bootstrap_vue_default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








vue_esm["a" /* default */].use(es["a" /* default */]);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store["a" /* store */],
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Y9O/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bDFw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dW2o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jQ72":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n9mN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/progress/_progress.js
var _progress = __webpack_require__("E9Zr");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/progress/progress.vue
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var progress = (_progress["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/progress/progress.vue
function injectStyle (ssrContext) {
  __webpack_require__("dW2o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  progress,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var progress_progress = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vV5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    // preferences set by user
    formInput: {
      questionQuantity: 0,
      includeOperators: [],
      constants: [{
        range: [0, 0],
        multiples: []
      }, {
        range: [0, 0],
        multiples: []
      }, {
        range: [],
        multiples: []
      }],
      subtractionVars: {
        includeNegativeAns: false,
        onlyNegativeAns: false
      },
      divisionVars: {
        wholeAnsOnly: false,
        modularRemainders: false,
        fractionRemainders: false, // 0.5 => ½, 0.25 => ¼, 0.75 => ¾ only
        decimalPlaces: 0
      },
      presentationVars: {
        inWords: false, // eg. nine plus seven
        includeUnits: [], // eg. £/cm
        showPlaceValues: false, // ie. H T O t h th
        missingNumber: false, // eg. "16 – ⬜ = 7"
        variableForms: false // eg. "7 = 16 – ⬜"
      }
    },
    // preferences set by default
    formDefaults: {
      questionQuantity: 20,
      includeOperators: ['➕', '➖'],
      constants: [{
        range: [0, 20],
        multiples: []
      }, {
        range: [0, 20],
        multiples: []
      }, {
        range: [],
        multiples: []
      }],
      subtractionVars: {
        includeNegativeAns: false,
        onlyNegativeAns: false
      },
      divisionVars: {
        wholeAnsOnly: true,
        modularRemainders: true,
        fractionRemainders: false, // 0.5 => ½, 0.25 => ¼, 0.75 => ¾ only
        decimalPlaces: 2
      },
      presentationVars: {
        inWords: false, // eg. nine plus seven
        includeUnits: [], // eg. £/cm
        showPlaceValues: false, // ie. H T O t h th
        missingNumber: false, // eg. "16 – ⬜ = 7"
        variableForms: false // eg. "7 = 16 – ⬜"
      }
    },
    // preference boundaries
    formOptions: {
      questionQuantity: {
        min: 0,
        max: 100
      },
      includeOperators: ['➕', '➖', '✖'],
      constantRange: {
        min: 0,
        max: 999
      },
      constantMultiples: ['2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '20', '100', '200'],
      includeUnits: {
        prepend: ['£', '€', '$'],
        append: ['p', '¢', '¥', 'cm', 'm', 'g', 'Kg', 'ml', 'L', 's', 'min', 'hr', '°C']
      }
    }
  },
  mutations: {
    resetAllInputs: function resetAllInputs(state) {
      state.formInput = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.formDefaults));
    },
    updateQuantity: function updateQuantity(state, value) {
      state.formInput.questionQuantity = value;
    },
    updateOperators: function updateOperators(state, value) {
      state.formInput.includeOperators = value;
    },
    updateRange: function updateRange(state, payload) {
      state.formInput.constants[payload.constant].range = payload.value;
    },
    updateMultiples: function updateMultiples(state, payload) {
      state.formInput.constants[payload.constant].multiples = payload.value;
    },
    updateNegativeAns: function updateNegativeAns(state, value) {
      state.formInput.subtractionVars.includeNegativeAns = value;
    },
    updatewholeAnsOnly: function updatewholeAnsOnly(state, value) {
      state.formInput.divisionVars.wholeAnsOnly = value;
    },
    updatemodularRemainders: function updatemodularRemainders(state, value) {
      state.formInput.divisionVars.modularRemainders = value;
    }
  },
  actions: {
    resetAllInputs: function resetAllInputs(_ref) {
      var commit = _ref.commit;

      commit('resetAllInputs');
    },
    updateQuantity: function updateQuantity(_ref2, value) {
      var commit = _ref2.commit;

      commit('updateQuantity', value);
    },
    updateOperators: function updateOperators(_ref3, value) {
      var commit = _ref3.commit;

      commit('updateOperators', value);
    },
    updateRange: function updateRange(_ref4, payload) {
      var commit = _ref4.commit;

      commit('updateRange', payload);
    },
    updateMultiples: function updateMultiples(_ref5, payload) {
      var commit = _ref5.commit;

      commit('updateMultiples', payload);
    },
    updateNegativeAns: function updateNegativeAns(_ref6, value) {
      var commit = _ref6.commit;

      commit('updateNegativeAns', value);
    },
    updatewholeAnsOnly: function updatewholeAnsOnly(_ref7, value) {
      var commit = _ref7.commit;

      commit('updatewholeAnsOnly', value);
    },
    updatemodularRemainders: function updatemodularRemainders(_ref8, value) {
      var commit = _ref8.commit;

      commit('updatemodularRemainders', value);
    }
  },
  getters: {
    constantMultiplesOptions: function constantMultiplesOptions(state) {
      return function (constantNo) {
        // options for multiples within scope of constant range
        return state.formOptions.constantMultiples.filter(function (multiple) {
          return multiple <= state.formInput.constants[constantNo].range[1];
        });
      };
    },
    constantsAvailable: function constantsAvailable(state) {
      var cConstants = 0;
      if (state.formInput.constants[0].range.length !== 0) {
        cConstants++;
      }
      if (state.formInput.constants[1].range.length !== 0) {
        cConstants++;
      }
      if (state.formInput.constants[2].range.length !== 0) {
        cConstants++;
      }
      return cConstants;
    },
    equationArray: function equationArray(state, getters) {
      // get demanded quantity and open empty array for equations
      var quantity = state.formInput.questionQuantity;
      var equations = [];

      // generate constant based on user prerequisites
      var constant = function constant(num, op) {
        var constant0 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

        var min = state.formInput.constants[num].range[0];
        var max = state.formInput.constants[num].range[1];

        // conditions for subtraction
        if (num === 1 && op === '➖') {
          if (!state.formInput.subtractionVars.includeNegativeAns) {
            max = constant0;
          }
          if (state.formInput.subtractionVars.onlyNegativeAns) {
            min = constant0;
          }
        }

        if (state.formInput.constants[num].multiples.length === 0) {
          return Math.floor(Math.random() * (max - min + 1) + min);
        } else {
          var selectedMultiple = state.formInput.constants[num].multiples[Math.floor(Math.random() * state.formInput.constants[num].multiples.length)];
          min /= selectedMultiple;
          max /= selectedMultiple;
          return Math.floor(Math.random() * (max - min + 1) + min) * selectedMultiple;
        }
      };

      // change emoji symbols to computing operators
      var deMoji = function deMoji(op) {
        return { '➕': '+', '➖': '-', '✖': '*', '➗': '/' }[op];
      };

      // change computing operator emoji symbol
      var reMoji = function reMoji(op) {
        return { '+': '➕', '-': '➖', '*': '✖', '/': '➗' }[op];
      };

      // populate array
      for (var i = 0; i < quantity; i++) {
        // generate operator from user options
        var operator = state.formInput.includeOperators[Math.floor(Math.random() * state.formInput.includeOperators.length)] || '➕';

        // generate first constant
        var constant0 = constant(0, operator);

        // generate second constant
        var constant1 = constant(1, operator, constant0);

        // assemble question
        var question = constant0 + ' ' + deMoji(operator) + ' ' + constant1;

        // evaluate answer
        // eslint-disable-next-line
        var answer = eval(question);
        question = question.replace(/\+|-|\*|\//gi, function (op) {
          return reMoji(op);
        });

        // append to array
        equations.push({ question: question, answer: answer });
      }

      return equations;
    }
  }
});

/***/ }),

/***/ "xBwK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7e2c56d45d9bc5704fcf.js